import { ReactNode } from 'react';
import { NotFound } from '@/screens/NotFound';
import { useFeatureGate } from '@/hooks';
import type { FeatureFlagKey } from '@/lib/feature-flag-constants';

interface FeatureGateRouteProps {
    flag: FeatureFlagKey;
    children: ReactNode;
}

export function FeatureGateRoute({ flag, children }: FeatureGateRouteProps) {
    const isEnabled = useFeatureGate(flag);

    if (!isEnabled) {
        return <NotFound />;
    }

    return <>{children}</>;
}
